<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 首页轮播图管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>

            <div class='handle-box'>

                <el-select v-model='query.status' placeholder='状态' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in statusOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>


                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button
                    type='primary'
                    icon='el-icon-plus'
                    class='handle-del mr10'
                    @click='addUser'
                >添加轮播图
                </el-button>
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>

<!--                <el-table-column label='名称' align='center' width='160px'>-->
<!--                    <template slot-scope='scope'>{{ scope.row.name }}</template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label='入驻企业数' align='center' width='120px'>-->
<!--                    <template slot-scope='scope'>{{ scope.row.num }}</template>-->
<!--                </el-table-column>-->
                <el-table-column label='轮播图' align='center'>
                    <template slot-scope='scope'>
                        <el-image
                            style='width: 200px; height: 200px'
                            :src='scope.row.imageUrl'
                            :preview-src-list='scope.row.photoUrlBannerList'>
                        </el-image>
                    </template>
                </el-table-column>

                                <el-table-column label='状态' align='center' width='120px'>
                                    <template slot-scope='scope'>{{ scope.row.status==0?"未下架":"上架中" }}</template>
                                </el-table-column>

                <el-table-column label='创建时间' align='center' width='200px'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>
                </el-table-column>

                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            type='text'
                            class='blue'
                            @click='handleStatus(scope.$index, scope.row)'
                        >{{ scope.row.status === 1 ? '下架' : '上架' }}
                        </el-button>
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-delete'-->
<!--                            class='red'-->
<!--                            @click='handleDelete(scope.$index, scope.row)'-->
<!--                        >删除-->
<!--                        </el-button>-->

                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <el-dialog title='查看专场招聘企业' :visible.sync='watchVisible' width='40%'>
            <el-table
                :data='SettledEnterprise'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >

                <el-table-column label='入驻企业名称' align='center' width='160px'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label='联系人' align='center' width='120px'>
                    <template slot-scope='scope'>{{ scope.row.concatName }}</template>
                </el-table-column>
                <el-table-column label='电话' align='center' width='120px'>
                    <template slot-scope='scope'>{{ scope.row.concatPhone }}</template>
                </el-table-column>
                <el-table-column label='操作' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleWatchDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>

                    </template>
                </el-table-column>

            </el-table>


            <span slot='footer' class='dialog-footer'>

                <el-button @click='watchVisible = false'>取 消</el-button>
             <el-button type='primary' @click='addEnterpriseVisible=true'>添加企业</el-button>
            </span>
        </el-dialog>
        <el-dialog title='添加轮播图' :visible.sync='addEnterpriseVisible' width='40%'>


            <el-select v-model='enterpriseValue' filterable placeholder='请选择要添加的企业'>
                <el-option
                    v-for='item in enterpriseOptions'
                    :key='item.value'
                    :label='item.label'
                    :value='item.value'>
                </el-option>
            </el-select>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addEnterpriseVisible = false'>取 消</el-button>
                <el-button type='primary' @click='AddEnterpriseHttp'>确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title='编辑轮播图' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='90px'>
                <el-form-item label='轮播图'>
                    <el-upload
                        ref='uploadRef'
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.photoUrlList'
                        action='https://jsonplaceholder.typicode.com/posts/'
                        :http-request='uploadFileLogo'
                        :auto-upload=true
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>


            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>


        <!-- 添加用户 -->
        <el-dialog title='添加轮播图' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='90px'>

                <el-form-item label='轮播图'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.photoUrlList'
                        ref='upload'

                        :http-request='uploadFileLogo'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                        <el-button @click='addVisible = false'>取 消</el-button>
                        <el-button type='primary' @click='addUserHttp'>确 定</el-button>
                    </span>
        </el-dialog>
    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            SettledEnterpriseId: '',
            amountIsShow: '1',
            camountIsShow: '1',
            enterpriseId: '',
            isDiscount: '0',
            dateSelectValue: [],
            watchVisible: false,
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            addEnterpriseVisible: false,
            mealOptions: [],
            cardOptions: [],
            mealValue: '',
            enterpriseSearchId: '',
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10,
                status: ''
            },
            updateType: 'add',
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            photoUrl: ''
            ,
            createForm: {

                imageUrl: ''

            }
            ,
            SettledEnterprise: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            statusOptions: [{ 'value': '', 'label': '全部' }, { 'value': '0', 'label': '未上架' }, {
                'value': '1',
                'label': '上架'
            }],
            enterpriseOptions: [],
            enterpriseValue: '',
            specialRecruitId: '',


        };
    },
    watch: {},
    created() {
        this.getData();
        this.getEnterpriseData();


    },


    methods: {
        handleRemove(file,fileList) {
            this.createForm.photoUrlList=[]
            for (const fileKey in fileList) {
                this.createForm.photoUrlList.push({"url":fileList[fileKey].url})

            }

        },
        beforeAvatarUpload(file) {
            console.log('hello');
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        uploadFileLogo(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.imageUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.imageUrl;
                    // that.createForm.photoUrlList = [];
                    that.createForm.photoUrlList.push({ url: picUrl });

                }
            }, err => {
                // 出现错误时的处理
            });
        },
        indexMethod(index) {
            return index + 1;
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        }
        ,
        getData() {
            let that = this;
            this.query.enterpriseId = this.enterpriseSearchId;
            this.http.getToken('/banner/getList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        for (const resKey in res.data.records) {
                           let data =  res.data.records[resKey];
                           data.photoUrlList = [{"url":data.imageUrl}]
                            console.log("redKey"+resKey)
                        }

                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        getSettledEnterprise(id) {
            let that = this;
            that.SettledEnterpriseId = id;
            let param = {};
            param.specialRecruitId = id;
            this.http.get('SpecialRecruit/getSettledEnterprise', param).then(res => {
                    if (res.code == 0) {
                        that.SettledEnterprise = res.data;

                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.post('SpecialRecruit/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        delSettledEnterpriseById(id) {
            let that = this;
            this.http.post('SpecialRecruit/delSettledEnterpriseById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getSettledEnterprise(that.SettledEnterpriseId);
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },
        // 删除操作
        handleWatchDelete(index, row) {

            // 二次确认删除
            let that = this;
            console.log('handleWatchDelete' + row.id);

            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delSettledEnterpriseById(row.specialRecruitEnterpriseId);

                })
                .catch(() => {
                });
        },
        getEnterpriseData() {

            let that = this;
            console.log('getEnterpriseData' + this.query.pageSize);
            let params = {};
            params.pageSize = 99999;
            params.pageIndex = 1;
            params.status = 1;
            this.http.get('/qwpenterprise/getList', params).then(res => {
                    if (res.code == 0) {

                        that.enterpriseOptions = [];
                        for (const i in res.data.records) {
                            that.enterpriseOptions.push({
                                'value': res.data.records[i].id,
                                'label': res.data.records[i].name
                            });
                        }
                        console.log('enterpriseOptions');
                        // that.tableData = res.data.records;
                        // that.pageTotal = parseInt(res.data.total);

                    }
                },
                err => {

                });
        },
        addUser() {

            this.createForm = {};
            this.form = {};
            this.createForm.photoUrl = '';
            this.dateSelectValue = [];
            this.createForm.photoUrlList = [];

            this.addVisible = true;

        },

        addUserHttp() {
            this.updateType = 'add';
            let that = this

            that.http.postToken('/banner/add', that.createForm).then(res => {
                if (res.code === 0) {
                    that.createForm = {};
                    that.dateSelectValue = [];
                    that.getData();
                    that.addVisible = false;
                    that.$message.success('添加成功');
                }

            });

        }
        ,
        editHttp() {
            let that = this;
            this.http.postToken('/banner/updateBanner', this.createForm).then(res => {
                if (res.code == 0) {
                    that.getData();
                    this.createForm = {};
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }

            });
        }
        ,
        handleStatus(index,row){
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '上架' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            } else {
                msg = '确定要' + '下架' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('/banner/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        AddEnterpriseHttp() {
            let that = this;

            // this.$refs.uploadRef.submit()
            let params = {};
            params.enterpriseId = this.enterpriseValue;
            params.specialRecruitId = this.specialRecruitId;
            this.http.post('SpecialRecruit/addEnterprise', params).then(res => {
                if (res.code == 0) {
                    that.getSettledEnterprise(this.SettledEnterpriseId);
                    that.getData();

                    that.$message.success('添加成功');
                }

            });
        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.createForm = {};
            this.createForm.name = row.name;
            this.createForm.id = row.id;
            this.createForm.photoUrl = row.photoUrl;
            this.createForm.photoUrlList = row.photoUrlList;
            this.dateSelectValue[0] = new Date(row.startTime);
            this.dateSelectValue[1] = new Date(row.endTime);
            this.editVisible = true;
        },
        handleWatch(index, row) {
            this.specialRecruitId = row.id;
            // this.idx = index;
            // this.createForm = {};
            // this.createForm.name = row.name;
            // this.createForm.id = row.id;
            // this.createForm.photoUrl = row.photoUrl;
            // this.createForm.photoUrlList=[]
            // this.dateSelectValue[0]= new Date(row.startTime)
            // this.dateSelectValue[1]= new Date(row.endTime)
            // this. createForm.photoUrlList.push({pic:row.photoUrl})
            this.getSettledEnterprise(row.id);
            this.watchVisible = true;
        },
        handlePreview(file) {
            console.log('handlePreview');

        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
